import React, {useState} from "react";
import "./SideandSearchBar.css";
import ytTVicon from "../Images/youtubeTVicon.png";
import ytmusicicon from "../Images/ytmusicicon.png";
import ytkidsicon from "../Images/youtube-kids.png";
import yticon from "../Images/youtube.png";

function SideandSearchBar(props){

    const[bgoverlay2,setbgoverlay2] = useState(false);
    const handlebgoverlay2 = ()=>{
        setbgoverlay2(false);
        setnotificationdropdown(false);
        setytappsdropdown(false);
        setcreatedropdown(false);
        setuserdropdown(false);
    }

    const[sidebarstate,setsidebarstate] = useState(false);
    const handlesidebarstate = ()=>{
        setsidebarstate(!sidebarstate);
    }

    const[userdropdown,setuserdropdown] = useState(false);
    const handleuserdropdown = ()=>{
        setbgoverlay2(true);
        setuserdropdown(!userdropdown);
        setnotificationdropdown(false);
        setytappsdropdown(false);
        setcreatedropdown(false);
    }

    const[notificationdropdown,setnotificationdropdown] = useState(false);
    const handlenotificationdropdown = ()=>{
        setbgoverlay2(true);
        setnotificationdropdown(!notificationdropdown);
        setuserdropdown(false);
        setytappsdropdown(false);
        setcreatedropdown(false);
    }

    const[ytappsdropdown,setytappsdropdown] = useState(false);
    const handleytappsdropdown = ()=>{
        setbgoverlay2(true);
        setytappsdropdown(!ytappsdropdown);
        setnotificationdropdown(false);
        setcreatedropdown(false);
        setuserdropdown(false);
    }

    const[createdropdown,setcreatedropdown] = useState(false);
    const handlecreatedropdown = ()=>{
        setbgoverlay2(true);
        setcreatedropdown(!createdropdown);
        setnotificationdropdown(false);
        setuserdropdown(false);
        setytappsdropdown(false);
    }

    const[searchterm, setsearchterm] = useState(null);
    const handlesearchterm = (e)=>{
        e.preventDefault();
        props.onSearchSubmit(searchterm);
    }

    const handleChange = (e)=>{
        setsearchterm(e.target.value);
    }

    return(
        <>
        {/* ======================  Search Bar  ======================== */}
        <div className="searchbar">
            <div className="yt-opt-btn">
                <h2 onClick={handlesidebarstate}><i class="fas fa-bars"></i></h2>
                <h2><img src={yticon} alt="NA" style={{width: "28px", height: "29px", marginBottom: "-6px"}} /> YouTube</h2>
            </div>
            <form className="searchbar-inp" onSubmit={handlesearchterm} >
                <input type="search" placeholder="Search" className="dark" onChange={handleChange} />
                <button type="submit" ><i className="fas fa-search"></i></button>
            </form>
            <div className="user-opt">
                <ul>
                    <li onClick={handlecreatedropdown}><i className="far fa-plus-square"></i></li>
                    <li onClick={handleytappsdropdown}><i className="fas fa-th"></i></li>
                    <li onClick={handlenotificationdropdown}><i className="far fa-bell"></i></li>
                    <li onClick={handleuserdropdown}><i className="far fa-user"></i></li>
                </ul>
            </div>
        </div>

        <div className={userdropdown?"user-dropdown":"displaynone"}></div>
        <div className={notificationdropdown?"notifications-dropdown":"displaynone"}>
            <h4>Notifications <i className="fas fa-cog"></i></h4>
            
        </div>

        <div className={ytappsdropdown?"ytapps-dropdown":"displaynone"}>
            <ul>
                <li><img src={ytTVicon} alt="NA" />YouTube TV</li>
                <hr style={{margin: "10px 0px", height: "1px", border: "none", backgroundColor: "#e7e7e7"}} />
                <li><img src={ytmusicicon} alt="NA" />YouTube Music</li>
                <li><img src={ytkidsicon} alt="NA" />YouTube Kids</li>
                <hr style={{margin: "10px 0px", height: "1px", border: "none", backgroundColor: "#e7e7e7"}} />
                <li><img src={yticon} alt="NA" />Creator Academy</li>
                <li><img src={yticon} alt="NA" />YouTube for Artists</li>
            </ul>
        </div>

        <div className={createdropdown?"create-dropdown":"displaynone"}>
            <ul>
                <li><i className="fas fa-video"></i>Upload Video</li>
                <li><i className="fas fa-headset"></i>Go live</li>
            </ul>
        </div>

        <div className={sidebarstate?"bg-overlay":""} onClick={handlesidebarstate} ></div>
        <div className={bgoverlay2?"bg-overlay2":""} onClick={handlebgoverlay2} ></div>

        {/* ===================== Side Bar ==================== */}

        <div className={sidebarstate?"sidebar":"hidden-sidebar"}>
            <div className="yt-opt-btn">
                <h2 onClick={handlesidebarstate}><i class="fas fa-bars"></i></h2>
                <h2><img src={yticon} alt="NA" style={{width: "28px", height: "29px", marginBottom: "-6px"}} /> YouTube</h2>
            </div>
            <div className="sidebar-section1">
                <ul>
                    <li><i className="fas fa-home"></i>Home</li>
                    <li><i className="far fa-compass"></i>Explore</li>
                    <li><i className="fas fa-money-bill"></i>Subscriptions</li>
                </ul>
            </div>
            <div className="sidebar-section2">
                <ul>
                    <li><i className="fas fa-university"></i>Library</li>
                    <li><i className="fas fa-history"></i>History</li>
                    <li><i className="fas fa-video"></i>Your Videos</li>
                    <li><i className="far fa-clock"></i>Watch Later</li>
                    <li><i className="far fa-thumbs-up"></i>Liked Videos</li>
                    <li><i className="fas fa-sort-down"></i>Show More</li>
                </ul>
            </div>
            <div className="sidebar-section3">

            </div>
        </div>
        </>
    );
}

export default SideandSearchBar;